import { useCallback, useState } from 'react';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { getERPList, getWmList } from './service';
import { AdminStore } from 'services/api/admin';

const ERPState = atom<{
  erpList: ERP.ERP[];
  wmList: ERP.ERPWm[];
}>({ erpList: [], wmList: [] });

export function useERPState() {
  return useAtomValue(ERPState);
}

export function useRefreshERP() {
  const [loading, setLoading] = useState(false);

  const setState = useSetAtom(ERPState);

  const refreshERP = useCallback(() => {
    setLoading(true);
    return Promise.all([getERPList(), getWmList()])
      .then(([erpList, wmList]) => {
        setState({
          erpList,
          wmList,
        });
      })
      .finally(() => setLoading(false));
  }, [setState]);

  return {
    loading,
    refreshERP,
  };
}

export function useRefreshWm() {
  const [loading, setLoading] = useState(false);

  const setState = useSetAtom(ERPState);

  const refreshWm = useCallback(() => {
    setLoading(true);
    return getWmList()
      .then((wmList) => {
        setState((pre) => ({
          ...pre,
          wmList,
        }));
      })
      .finally(() => setLoading(false));
  }, [setState]);

  return {
    loading,
    refreshWm,
  };
}

export const storesCache = {
  current: undefined as undefined | AdminStore[],
};
